const W = "#F8FAFC";

export const TreadPattern = ({ type = "rib", className = "", accent = "#FFB300" }) => {
  const els = [];

  if (type === "zigzag") {
    for (let r = 0; r < 2; r++) {
      const y0 = 34 + r * 36;
      const pts = [];
      for (let i = 0; i <= 10; i++) pts.push(`${i * 20},${y0 + (i % 2 ? -13 : 13)}`);
      els.push(
        <polyline key={r} points={pts.join(" ")} fill="none" stroke={r ? accent : W} strokeWidth="5" strokeLinejoin="miter" />
      );
    }
  } else if (type === "lug") {
    for (let i = 0; i < 9; i++) {
      els.push(
        <rect key={i} x={i * 23 + 5} y="16" width="10" height="68" fill={i % 4 === 2 ? accent : W} opacity="0.92" transform="skewX(-8)" />
      );
    }
  } else if (type === "rib") {
    for (let i = 0; i < 6; i++) {
      els.push(
        <rect key={i} x={13 + i * 31} y="12" width="11" height="76" fill={i === 2 ? accent : W} opacity="0.92" />
      );
    }
  } else if (type === "block") {
    for (let r = 0; r < 3; r++) {
      for (let i = 0; i < 7; i++) {
        const off = r % 2 ? 14 : 0;
        els.push(
          <rect key={`${r}-${i}`} x={i * 28 - 6 + off} y={15 + r * 28} width="19" height="17" rx="2" fill={(r * 7 + i) % 9 === 3 ? accent : W} opacity="0.88" />
        );
      }
    }
  } else if (type === "riblug") {
    for (let i = 0; i < 5; i++) {
      els.push(
        <rect key={`l${i}`} x={i * 17 + 4} y="12" width="8" height="30" fill={i === 2 ? accent : W} opacity="0.9" transform="skewX(-10)" />
      );
      els.push(
        <rect key={`r${i}`} x={i * 17 + 112} y="58" width="8" height="30" fill={i === 2 ? accent : W} opacity="0.9" transform="skewX(-10)" />
      );
    }
    els.push(
      <rect key="c1" x="94" y="12" width="7" height="76" fill={W} opacity="0.9" />,
      <rect key="c2" x="106" y="12" width="7" height="76" fill={W} opacity="0.9" />
    );
  } else if (type === "compound") {
    els.push(
      <circle key="c" cx="100" cy="50" r="34" fill="none" stroke={W} strokeWidth="5" opacity="0.9" />,
      <circle key="a" cx="100" cy="50" r="12" fill={accent} />,
      <line key="l1" x1="100" y1="0" x2="100" y2="10" stroke={W} strokeWidth="4" />,
      <line key="l2" x1="100" y1="90" x2="100" y2="100" stroke={W} strokeWidth="4" />,
      <line key="l3" x1="46" y1="50" x2="56" y2="50" stroke={W} strokeWidth="4" />,
      <line key="l4" x1="144" y1="50" x2="154" y2="50" stroke={W} strokeWidth="4" />
    );
  }

  return (
    <svg viewBox="0 0 200 100" className={className} preserveAspectRatio="xMidYMid slice" aria-hidden="true">
      {els}
    </svg>
  );
};

export default TreadPattern;
